import { considerationToDimension } from '../../../constants/Constants'
import {
  StoreData,
  getDimensionName,
  getConsiderationName,
} from '../getPageContext'

export const buildConsiderationComparisonContent = (
  data?: StoreData
): Record<string, unknown> => {
  if (!data?.allInfo) return {}

  const { allInfo, considerationsComparison, locale } = data

  // Determine which dimension the comparison data belongs to
  let selectedDimensionId: number | null = null
  if (considerationsComparison && considerationsComparison.length > 0) {
    const firstId = considerationsComparison[0].id
    const meta = considerationToDimension[firstId] as
      | { dimension: number }
      | undefined
    if (meta) selectedDimensionId = meta.dimension
  }
  // Build the selected dimension with full quarter history
  let selectedDimension: Record<string, unknown> | null = null
  if (selectedDimensionId && considerationsComparison) {
    const dim = allInfo.LatestCityDimensions.find(
      (d) => d.id === selectedDimensionId
    )
    const considerations = considerationsComparison
      .map((c) => {
        const cAny = c as Record<string, unknown>
        return {
          name: getConsiderationName(c.id, undefined, locale),
          currentQuarter: c.curr !== null ? Math.round(c.curr) : null,
          prev1: c.prev_1 !== null ? Math.round(c.prev_1) : null,
          prev2:
            cAny.prev_2 !== null && cAny.prev_2 !== undefined
              ? Math.round(cAny.prev_2 as number)
              : null,
          prev3:
            cAny.prev_3 !== null && cAny.prev_3 !== undefined
              ? Math.round(cAny.prev_3 as number)
              : null,
        }
      })
      .sort((a, b) => (b.currentQuarter ?? 0) - (a.currentQuarter ?? 0))

    selectedDimension = {
      name: getDimensionName(selectedDimensionId, dim?.name, locale),
      score: dim ? Math.round(dim.value) : null,
      considerations,
    }
  }

  // Build other dimensions with current scores only
  const otherDimensions = allInfo.LatestCityDimensions.filter(
    (d) => d.id !== selectedDimensionId
  ).map((dim) => {
    const considerations = allInfo.LatestCityConsiderations.filter((c) => {
      const meta = considerationToDimension[c.id] as
        | { dimension: number }
        | undefined
      return meta && meta.dimension === dim.id
    })
      .map((c) => ({
        name: getConsiderationName(c.id, c.name, locale),
        score: Math.round(c.value),
      }))
      .sort((a, b) => b.score - a.score)

    return {
      name: getDimensionName(dim.id, dim.name, locale),
      score: Math.round(dim.value),
      considerations,
    }
  })

  return {
    selectedTab: selectedDimension,
    otherDimensions,
  }
}
